<template>
	<div id="pdf-app">
		<PSPDFKitContainer :pdfFile="pdfFile" @loaded="handleLoaded" />
	</div>
</template>

<script>
import PSPDFKitContainer from '@/components/PSPDFKitContainer';

export default {
	data() {
		return {
			pdfFile: process.env.VUE_APP_SERVER+"my/course/"+this.$route.params.course_id+"/content-gp/"+this.$route.params.group_id+"/content/"+this.$route.params.id+"/download?token="+ this.$store.state.user['token'],
		};
	},
	/**
	 * Render the `PSPDFKitContainer` component.
	 */
	components: {
		PSPDFKitContainer,
	},
	/**
	 * Our component has two methods — one to check when the document is loaded, and the other to open the document.
	 */
	methods: {
		handleLoaded(instance) {
			console.log('PSPDFKit has loaded: ', instance);
			// Do something.
		},
	},
};
</script>

<style>
#pdf-app {
	text-align: center;
	color: #2c3e50;
}
</style>
